import { render, staticRenderFns } from "./SentCampaigns.vue?vue&type=template&id=0ffd45ce"
import script from "./SentCampaigns.vue?vue&type=script&lang=js"
export * from "./SentCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports